import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { recruitingHiringCriteriaCategoryQuerySchema } from './recruiting-hiring-criteria-category-query-schema';

export const recruitingHiringCriteriaCategoryUpdateSchema = recruitingHiringCriteriaCategoryQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: statusMutationSchema });

export type RecruitingHiringCriteriaCategoryUpdateSchema = z.infer<typeof recruitingHiringCriteriaCategoryUpdateSchema>;

export const recruitingHiringCriteriaCategoryCreateSchema = recruitingHiringCriteriaCategoryUpdateSchema.pick({
  name: true,
  status: true,
});
export type RecruitingHiringCriteriaCategoryCreateSchema = z.infer<typeof recruitingHiringCriteriaCategoryCreateSchema>;
